<template>
  <v-card
    class="building-card"
    :class="{
      isSelected: isSelected,
      selectable: isSelectable,
    }"
    :elevation="isSelected ? 4 : 2"
  >
    <v-card-title class="building-card__title">
      <v-icon left color="contrast">mdi-office-building</v-icon>
      {{ building.name }}
      <v-spacer></v-spacer>
      <v-chip
        v-if="isSelected && isSelectable"
        small
        color="success"
        class="already-isSelected-chip"
      >
        <div style="display: flex; gap: 4px; align-items: center">
          <div>Selected</div>
          <v-icon v-if="isSelected && isSelectable" color="success" small>
            mdi-check-circle
          </v-icon>
        </div>
      </v-chip>
    </v-card-title>

    <v-card-item class="building-card__content">
      <div v-if="building.description" class="detail-row description-row">
        <v-icon small color="contrast">mdi-text</v-icon>
        <span class="detail-text">{{ building.description }}</span>
      </div>

      <div v-if="building.address" class="detail-row">
        <v-icon small color="contrast">mdi-map-marker</v-icon>
        <span class="detail-text">{{ building.address }}</span>
      </div>

      <div v-if="building.gps" class="detail-row">
        <v-icon small color="contrast">mdi-crosshairs-gps</v-icon>
        <span class="detail-text">{{ building.gps }}</span>
      </div>

      <div
        v-if="!building.description && !building.address && !building.gps"
        class="detail-row no-details"
      >
        <v-icon small color="contrast">mdi-information-outline</v-icon>
        <span class="detail-text">No details available</span>
      </div>
    </v-card-item>
    <v-spacer></v-spacer>
    <!-- Card actions -->
    <v-card-actions class="building-card__actions">
      <v-spacer></v-spacer>
      <!-- Edit and Delete buttons (shown when not selectable) -->
      <template v-if="!isSelectable">
        <v-btn color="primary" @click="handleEdit" variant="text">
          <v-icon left>mdi-pencil</v-icon>
          Edit
        </v-btn>
        <v-btn color="error" @click="handleDelete" variant="text">
          <v-icon left>mdi-delete</v-icon>
          Remove
        </v-btn>
      </template>
      <!-- Select/Unselect button (shown when selectable) -->
      <template v-else>
        <v-btn
          :color="isSelected ? 'error' : 'primary'"
          @click="handleClick"
          variant="text"
        >
          <v-icon left>
            {{ isSelected ? "mdi-close-circle" : "mdi-check-circle" }}
          </v-icon>
          {{ isSelected ? "Unselect" : "Select" }}
        </v-btn>
      </template>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "BuildingCard",

  props: {
    building: {
      type: Object,
      required: true,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
    isSelectable: {
      type: Boolean,
      default: false,
    },
  },

  emits: ["toggle", "edit", "delete"],

  methods: {
    handleClick() {
      this.$emit("toggle", this.building);
    },

    handleEdit() {
      this.$emit("edit", this.building);
    },

    handleDelete() {
      this.$emit("delete", this.building.id);
    },
  },
};
</script>

<style scoped>
.building-card {
  margin: 8px;
  transition: all 0.2s ease;
  position: relative;
  background-color: rgba(255, 255, 255, 0.05) !important;
  border: 1px solid transparent !important;
}

.building-card__title {
  font-weight: bold;
  font-size: 1.2em;
  color: var(--contrastColor) !important;
  padding-bottom: 4px;
}

.building-card__content {
  padding-top: 0;
}

.building-card__field {
  margin-bottom: 8px;
}

.detail-row {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 6px;
}

.detail-row .v-icon {
  margin-top: 2px;
  flex-shrink: 0;
}

.detail-text {
  font-size: 0.875rem;
  line-height: 1.4;
  color: var(--contrastColor) !important;
}

.description-row {
  font-style: italic;
  white-space: pre-wrap;
}

.no-details {
  font-style: italic;
  display: flex;
  align-items: center;
  padding-left: 5px;
}

.isSelected {
  border: 1px solid var(--contrastColor) !important;
}
</style>
